import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store/index';
import config from './config';
import './permission';
import './utils/version-update';
import plugins from './plugins/index';
import '@/static/less/index.less';
import 'vant/lib/index.css';
// Toast
import 'vant/es/toast/style';
// Dialog
import 'vant/es/dialog/style';
// Notify
import 'vant/es/notify/style';
// ImagePreview
import 'vant/es/image-preview/style';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { useDict } from '@/utils/dict';

if (window.location.hash.startsWith('#/')) {
  // 直接替换掉 hash 中的 #/
  const newUrl = window.location.href.replace('#/', '');
  // 替换浏览器地址栏的 URL，不刷新页面
  console.log('重写 URL 为:', newUrl);
  window.location.href = newUrl;
}

const app = createApp(App);
app.config.globalProperties.$store = store;
app.config.globalProperties.config = config;
app.config.globalProperties.useDict = useDict;

app.use(ElementPlus);
app.use(plugins);
app.use(router);
app.use(store);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.mount('#app');
